.root {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  justify-content: space-between;
  padding: 10px 10px 10px 16px;
  background: var(--light-100);
  margin-left: 60px;
  border-radius: 16px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.09);
  overflow: hidden;

  &.downvoteFeedback,
  &.upvoteFeedback {
    padding: 18px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    .submitButton {
      margin-left: auto;
      margin-top: 9px;
    }

    .submitButtons {
      display: flex;
      gap: 4px;
      width: 100%;
      justify-content: space-between;
      margin-top: 9px;
    }
  }

  textarea {
    width: 303px;
    height: 63px;
  }
}

.closeButton {
  position: absolute;
  top: 6px;
  right: 6px;
}

.buttons {
  display: flex;
  gap: 4px;
}

.chips {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  width: 308px;

  .chip {
    border-radius: 6px;

    svg {
      fill: transparent;
    }

    &.moreOrLessChip {
      background: var(--light-100);
    }
  }
}

.loadingBar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  pointer-events: none;
}

.loadingBarFill {
  height: 100%;
  background: var(--dark-40);
  transform: scaleX(0);
  transform-origin: left center;
  animation: contentRatingLoadingBar 5s linear forwards;
}

@media (prefers-reduced-motion: reduce) {
  .loadingBarFill {
    animation: none;
    transform: scaleX(1);
  }
}

@keyframes contentRatingLoadingBar {
  to {
    transform: scaleX(1);
  }
}
